//types.ts
export interface Category {
  id: number;
  cat_id?: number; // Some APIs might use cat_id instead of id
  cat_name: string;
  cat_short_name: string;
  cat_desc?: string | null;
  status: number;
  cat_main_image?: string | null;
  createddt?: string;
  updateddt?: string | null;
  createdAt?: string; // MongoDB timestamp format
  updatedAt?: string; // MongoDB timestamp format
  __v?: number; // MongoDB version key
  _id?: string; // MongoDB ObjectId
}

export interface CategoryFormData {
  cat_name: string;
  cat_short_name: string;
  cat_desc: string;
  status: number;
  cat_main_image?: File;
  cat_id?: number; // For updates
}

export interface ApiResponse<T> {
  error: boolean;
  message: string;
  result?: T;
  data?: T;
  count?: number;
  total?: number;
  total_records?: number;
  recId?: number;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
  start?: number;
  search_str?: string;
}

export interface CategoryListParams extends PaginationParams {
  // Additional parameters specific to category listing
}

export interface CategoryCountParams {
  search_str?: string;
}

export interface CategoryDetailParams {
  cat_id: number;
}

export interface CategoryDeleteParams {
  cat_id: number;
}

// Add/Update category request interfaces
export interface AddCategoryRequest {
  cat_name: string;
  cat_short_name: string;
  cat_desc?: string;
  status?: number;
  cat_main_image?: File;
}

export interface UpdateCategoryRequest {
  cat_id: number;
  cat_name: string;
  cat_short_name: string;
  cat_desc?: string;
  status?: number;
  cat_main_image?: File;
}

// Status enum for better type safety
export enum CategoryStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  SUSPENDED = 2,
  DELETED = 3,
}

// Form validation errors
export interface FormErrors {
  [key: string]: string;
}

// Snackbar state
export interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

// API Configuration
export const API_CONFIG = {
  BASE_URL: 'http://62.72.43.31:3000',
  AUTH_KEY: '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3',
  LOCALHOST_BASE_URL: 'http://localhost:8080',
  APP_AUTH_KEY: '34SDF#$DSF23cxv458we324cvxjmwsdf',
  ENDPOINTS: {
    ADMIN_LOGIN: '/admin/login',
    ADMIN_REGISTER: '/admin/register',
    CATEGORY_ADD: '/category/add',
    CATEGORY_UPDATE: '/category/update',
    CATEGORY_DELETE: '/category/delete',
    CATEGORY_LIST: '/category/list',
    CATEGORY_COUNT: '/category/count',
    CATEGORY_DETAIL: '/category/detail',
  },
};

// Admin login interfaces
export interface AdminLoginRequest {
  email: string;
  password: string;
}

export interface AdminLoginResponse {
  error: boolean;
  message?: string;
  token?: string;
  user?: {
    id: number;
    email: string;
    name?: string;
  };
}

export interface AdminRegisterRequest {
  email: string;
  password: string;
  name?: string;
}

export interface AdminRegisterResponse {
  error: boolean;
  message?: string;
  user?: {
    id: number;
    email: string;
    name?: string;
  };
}

export class NetworkError extends Error {
  status?: number;
  
  constructor(message: string) {
    super(message);
    this.name = 'NetworkError';
  }
}

export interface ValidationResult {
  isValid: boolean;
  message?: string;
}

export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PASSWORD: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
};

export const VALIDATION_MESSAGES = {
  EMAIL_REQUIRED: 'Email is required',
  EMAIL_INVALID: 'Please enter a valid email address',
  PASSWORD_REQUIRED: 'Password is required',
  PASSWORD_INVALID: 'Password must be at least 8 characters with uppercase, lowercase, number and special character',
};

export interface Unit {
  id: number;
  unit_id?: number;
  unit_name: string;
  unit_short_name: string;
  unit_desc?: string | null;
  createddt?: string;
  updateddt?: string | null;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
  _id?: string;
}

export interface UnitFormData {
  unit_name: string;
  unit_short_name: string;
  unit_desc: string;
}

export interface ApiResponse<T> {
  error: boolean;
  message: string;
  result?: T;
  data?: T;
  count?: number;
  total?: number;
  total_records?: number;
  recId?: number;
}

export interface UnitListParams {
  // No parameters for unit list as per API documentation
}

export interface UnitDeleteParams {
  unit_id: number;
}

// Form validation errors
export interface FormErrors {
  key:  string;
}

// Snackbar state
export interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

// types/delivery.ts

export interface DeliveryModel {
  id: number;
  model_id: number; // changed from id to model_id for consistency with API
  model_name: any;
  delivery_type: number; // 0 - hour basis, 1 - days basis
  hours: number;
  days: number;
  display_text: string;
  status: number; // 0 - Inactive, 1 - Active, 2 - Delete
  is_default: number; // 0 or 1
  is_restricted: number; // 1 - all customers, 2 - selected customers
  createddt: string;
  updateddt: string | null;
}

export interface DeliveryModelFormData {
  model_id?: number; // optional for create, required for update
  model_name: string;
  delivery_type: number; // 0 or 1
  hours: number;
  days: number;
  display_text: string;
  status: number;
  is_default: number;
  is_restricted: number;
}

export interface DeliveryModelResponse {
  error: boolean;
  message: string;
  result?: DeliveryModel[];
  record?: DeliveryModel[];
  recId?: number;
}

export interface DeleteDeliveryModelRequest {
  model_id: number;
}

export interface GetDeliveryModelDetailRequest {
  model_id: number;
}

export const DELIVERY_TYPE_OPTIONS = [
  { value: 0, label: 'Hour Basis', description: 'Delivery within specific hours from order placed' },
  { value: 1, label: 'Days Basis', description: 'Delivery within specific days from order placed' }
];

export const STATUS_OPTIONS = [
  { value: 0, label: 'Inactive', color: '#f44336' },
  { value: 1, label: 'Active', color: '#4caf50' },
  { value: 2, label: 'Delete', color: '#9e9e9e' }
];

export const IS_DEFAULT_OPTIONS = [
  { value: 0, label: 'No' },
  { value: 1, label: 'Yes' }
];

export const IS_RESTRICTED_OPTIONS = [
  { value: 1, label: 'All Customers' },
  { value: 2, label: 'Selected Customers' }
];

// src/features/admin/subCategoryTypes.ts
export interface SubCategory {
  id: number;
  sub_cat_id?: number; // Some APIs might use sub_cat_id instead of id
  sub_cat_name: string;
  sub_cat_short_name: string;
  sub_cat_desc?: string | null;
  cat_id: number; // Parent category ID
  status: number;
  sub_cat_main_image?: string | null;
  createddt?: string;
  updateddt?: string | null;
  createdAt?: string; // MongoDB timestamp format
  updatedAt?: string; // MongoDB timestamp format
  __v?: number; // MongoDB version key
  _id?: string; // MongoDB ObjectId
}

export interface SubCategoryFormData {
  sub_cat_name: string;
  sub_cat_short_name: string;
  sub_cat_desc: string;
  cat_id: number;
  status: number;
  sub_cat_main_image?: File;
  sub_cat_id?: number; // For updates
}

export interface SubCategoryApiResponse<T> {
  error: boolean;
  message: string;
  result?: T;
  data?: T;
  count?: number;
  total?: number;
  total_records?: number;
  recId?: number;
}

export interface SubCategoryPaginationParams {
  page?: number;
  limit?: number;
  start?: number;
  search_str?: string;
  cat_id?: number;
}

export interface SubCategoryListParams extends SubCategoryPaginationParams {
  // Additional parameters specific to subcategory listing
}

export interface SubCategoryListByCatIdParams {
  cat_id: number;
}

export interface SubCategoryCountParams {
  search_str?: string;
}

export interface SubCategoryDetailParams {
  sub_cat_id: number;
}

export interface SubCategoryDeleteParams {
  sub_cat_id: number;
}

// Add/Update subcategory request interfaces
export interface AddSubCategoryRequest {
  cat_id: number;
  sub_cat_name: string;
  sub_cat_short_name: string;
  sub_cat_desc?: string;
  status?: number;
  sub_cat_main_image?: File;
}

export interface UpdateSubCategoryRequest {
  sub_cat_id: number;
  cat_id: number;
  sub_cat_name: string;
  sub_cat_short_name: string;
  sub_cat_desc?: string;
  status?: number;
  sub_cat_main_image?: File;
}

// Status enum for better type safety
export enum SubCategoryStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  SUSPENDED = 2,
  DELETED = 3,
}

// Form validation errors
export interface SubCategoryFormErrors {
  [key: string]: string;
}

// Snackbar state
export interface SubCategorySnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

// API Configuration for SubCategory
export const SUB_CATEGORY_API_CONFIG = {
  BASE_URL: (process.env.REACT_APP_SERVER_ENDPOINT || '').replace(/\/$/, ''),
  AUTH_KEY: '7b4e1fd03f57885c1ff900ad76ea3810bb7160c7157a4c31cf2de3',
  ENDPOINTS: {
    SUBCATEGORY_ADD: '/subcategory/add',
    SUBCATEGORY_UPDATE: '/subcategory/update',
    SUBCATEGORY_DELETE: '/subcategory/delete',
    SUBCATEGORY_LIST: '/subcategory/list',
    SUBCATEGORY_COUNT: '/subcategory/count',
    SUBCATEGORY_DETAIL: '/subcategory/detail',
    SUBCATEGORY_LIST_BY_CAT_ID: '/subcategory/listbycatid',
  },
};



// src/features/admin/types.ts

// Shipping charge condition types
// src/features/admin/shippingTypes.ts
export interface ShippingCharge {
  id: number;
  model_id?: number;
  model_name: string;
  shipping_charge_condition: any; // Can be object or array based on type
  status: number;
  is_default: number;
  is_restricted: number;
  createddt?: string;
  updateddt?: string | null;
  active?: number; // Alternative field name
  default?: boolean; // Alternative field name
}

export interface ShippingChargeFormData {
  model_name: string;
  shipping_charge_condition: any;
  active: number;
  is_default: number;
  is_restricted: number;
  model_id?: number; // For updates
}

// Shipping charge condition types
export interface DeliveryPartnerCharge {
  courier_name: string;
  base_distance_km: number;
  base_weight_grams: number;
  base_charge: number;
  additional_per_km: number;
  additional_charge_per_km: number;
  additional_per_grams: number;
  additional_charge_per_grams: number;
}

export interface FreeCharge {
  charge: number; // Should be 0
}

export interface FlatCharge {
  flat_charge: number;
}

export interface OrderAmountBasedCharge {
  min: number;
  max: number;
  rate: number;
}

export interface BuyerRegionBasedCharge {
  region_name: string;
  base_distance_km: number;
  base_weight_grams: number;
  base_charge: number;
  additional_per_km: number;
  additional_charge_per_km: number;
  additional_per_grams: number;
  additional_charge_per_grams: number;
}

export interface AlternateWarehouseCharge {
  flat_charge: number;
}

// Shipping charge types enum
export enum ShippingChargeType {
  FREE = 'free',
  FLAT = 'flat',
  DELIVERY_PARTNER = 'delivery_partner',
  ORDER_AMOUNT = 'order_amount',
  BUYER_REGION = 'buyer_region',
  ALTERNATE_WAREHOUSE = 'alternate_warehouse'
}

// API Response interface
export interface ShippingApiResponse<T> {
  error: boolean;
  message: string;
  result?: T;
  data?: T;
  count?: number;
  total?: number;
  total_records?: number;
}

// Request interfaces
export interface AddShippingChargeRequest {
  model_name: string;
  shipping_charge_condition: string; // JSON string
  active?: number;
  is_default?: number;
  is_restricted?: number;
}

export interface UpdateShippingChargeRequest {
  model_id: number;
  model_name: string;
  shipping_charge_condition: string; // JSON string
  active?: number;
  is_default?: number;
  is_restricted?: number;
}

export interface DeleteShippingChargeRequest {
  model_id: number;
}

export interface GetShippingChargeByIdRequest {
  model_id: number;
}

export interface SetDefaultShippingChargeRequest {
  model_id: number;
}

// Form validation errors
export interface ShippingFormErrors {
  [key: string]: string;
}

// Snackbar state
export interface ShippingSnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}

// Status enums
export enum ShippingStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  DELETED = 2,
}

export enum ShippingRestriction {
  ALL_CUSTOMERS = 1,
  SELECTED_CUSTOMERS = 2,
}

export enum ShippingDefault {
  NOT_DEFAULT = 0,
  DEFAULT = 1,
}

// Predefined shipping charge templates
export const SHIPPING_CHARGE_TEMPLATES = {
  FREE: {
    name: 'Free Shipping',
    type: ShippingChargeType.FREE,
    condition: { charge: 0 }
  },
  FLAT: {
    name: 'Flat Charge',
    type: ShippingChargeType.FLAT,
    condition: { flat_charge: 0 }
  },
  DELIVERY_PARTNER: {
    name: 'Delivery Partner Based',
    type: ShippingChargeType.DELIVERY_PARTNER,
    condition: [{
      courier_name: '',
      base_distance_km: 5,
      base_weight_grams: 100,
      base_charge: 10,
      additional_per_km: 1,
      additional_charge_per_km: 0.5,
      additional_per_grams: 100,
      additional_charge_per_grams: 0.20
    }]
  },
  ORDER_AMOUNT: {
    name: 'Order Amount Based',
    type: ShippingChargeType.ORDER_AMOUNT,
    condition: [
      { min: 0, max: 100, rate: 50 },
      { min: 101, max: 50000, rate: 0 }
    ]
  },
  BUYER_REGION: {
    name: 'Region Based',
    type: ShippingChargeType.BUYER_REGION,
    condition: [{
      region_name: '',
      base_distance_km: 5,
      base_weight_grams: 100,
      base_charge: 10,
      additional_per_km: 1,
      additional_charge_per_km: 0.5,
      additional_per_grams: 100,
      additional_charge_per_grams: 0.20
    }]
  },
  ALTERNATE_WAREHOUSE: {
    name: 'Alternate Warehouse',
    type: ShippingChargeType.ALTERNATE_WAREHOUSE,
    condition: { flat_charge: 0 }
  }
};

// API Configuration
export const SHIPPING_API_CONFIG = {
  BASE_URL: 'http://62.72.43.31:3000/',
  ENDPOINTS: {
    ADD_SHIPPING_CHARGE: '/globalsettings/addshippingcharge',
    UPDATE_SHIPPING_CHARGE: '/globalsettings/updateshippingcharge',
    LIST_SHIPPING_CHARGES: '/globalsettings/listShippingCharges',
    DELETE_SHIPPING_CHARGE: '/globalsettings/deleteShippingChargeModel',
    GET_SHIPPING_CHARGE_BY_ID: '/globalsettings/getShippingChargebyID',
    SET_DEFAULT_SHIPPING_CHARGE: '/globalsettings/setDefaultShippingCharge',
  },
};

// src/features/admin/types.ts - UPDATED VERSION WITH PRODUCT TYPES

// Existing Category types...
export interface Category {
  id: number;
  cat_id?: number;
  cat_name: string;
  cat_short_name: string;
  cat_desc?: string | null;
  status: number;
  cat_main_image?: string | null;
  createddt?: string;
  updateddt?: string | null;
  createdAt?: string;
  updatedAt?: string;
  __v?: number;
  _id?: string;
}

export interface CategoryFormData {
  cat_name: string;
  cat_short_name: string;
  cat_desc: string;
  status: number;
  cat_main_image?: File;
  cat_id?: number;
}

// PRODUCT TYPES START HERE
export interface Product {
  name: string;
  sku: any;
  description: any;
  price: any;
  cost_price: any;
  stock_quantity: any;
  category_id: any;
  brand_id: any;
  weight: any;
  dimensions: any;
  images: any;
  id: number;
  product_id?: number;
  cat_id: number;
  sub_cat_id?: number | null;
  vendor_id?: number | null;
  cat_name?: string;
  sub_cat_name?: string;
  prod_name: string;
  product_name?: string; // Alternative field name
  prod_short_name: string;
  product_short_name?: string; // Alternative field name
  prod_desc?: string | null;
  product_desc?: string | null; // Alternative field name
  status: number;
  product_unit: string;
  product_quantity: number;
  product_price: number;
  product_retail_price: number;
  product_discount?: number;
  discount_type?: number; // 1 - Percentage, 2 - Fixed Amount
  currency: string;
  availability?: number; // 1 - Available, 0 - Unavailable
  max_order_quantity?: number;
  tax1_name?: string | null;
  tax1_per?: number | null;
  tax2_name?: string | null;
  tax2_per?: number | null;
  product_stock: number;
  shipping_charge?: number | null;
  shipping_model?: number | null;
  shipping_price_models?: number | null;
  delivery_model?: number | null;
  product_main_image?: string | null;
  createddt?: string;
  updateddt?: string | null;
  createdAt?: string;
  updatedAt?: string;
  relevance?: number; // For search results
}

export interface ProductImage {
  id: number;
  product_id: number;
  product_image: string;
  thumb_nail: string;
  createddt?: string;
  updateddt?: string | null;
}

export interface ProductFormData {
  name: any;
  sku: any;
  description: any;
  price: number;
  stock_quantity: number;
  category_id: any;
  brand_id: string;
  weight: string;
  dimensions: string;
  cost_price: string;
  images: boolean;
  product_name: string;
  product_short_name: string;
  product_desc: string;
  status: number;
  product_unit: string;
  product_quantity: number;
  currency: string;
  product_price: number;
  product_retail_price: number;
  discount_type: number;
  product_discount: number;
  cat_id: number;
  sub_cat_id?: number;
  availability: number;
  max_order_quantity: number;
  tax1_name?: string;
  tax1_per?: number;
  tax2_name?: string;
  tax2_per?: number;
  shipping_charge?: number;
  shipping_model?: number;
  delivery_model?: number;
  product_stock: number;
  vendor_id?: number;
  product_main_image?: File;
  product_id?: number; // For updates
}

// API Request/Response interfaces for Products
export interface AddProductRequest {
  product_name: string;
  product_short_name: string;
  product_desc?: string;
  status?: number;
  product_unit: string;
  product_quantity: number;
  currency: string;
  product_price: number;
  product_retail_price: number;
  discount_type?: number;
  product_discount?: number;
  cat_id: number;
  sub_cat_id?: number;
  availability?: number;
  max_order_quantity?: number;
  tax1_name?: string;
  tax1_per?: number;
  tax2_name?: string;
  tax2_per?: number;
  shipping_charge?: number;
  shipping_model?: number;
  delivery_model?: number;
  product_stock: number;
  vendor_id?: number;
  product_main_image?: File;
}

export interface UpdateProductRequest extends AddProductRequest {
  product_id: number;
}

export interface ProductListParams extends PaginationParams {
  sortby?: 'price' | 'newest' | 'relevance';
  sortorder?: 'desc' | 'asc';
}

export interface ProductSearchParams extends ProductListParams {
  search_str?: string;
}

export interface ProductDetailParams {
  product_id: number;
}

export interface ProductDeleteParams {
  product_id: number;
}

export interface ProductCountParams {
  search_str?: string;
}

export interface ProductSearchResponse extends ApiResponse<Product[]> {
  produclist?: Product[]; // Alternative field name from API
}

export interface ProductDetailResponse extends ApiResponse<Product[]> {
  productdet?: Product[]; // API returns array with single product
  imagesdet?: ProductImage[]; // Additional product images
}

// Common types (existing)
export interface ApiResponse<T> {
  error: boolean;
  message: string;
  result?: T;
  data?: T;
  count?: number;
  total?: number;
  total_records?: number;
  recId?: number;
}

export interface PaginationParams {
  page?: number;
  limit?: number;
  start?: number;
  search_str?: string;
}

export interface CategoryListParams extends PaginationParams {}

export interface CategoryCountParams {
  search_str?: string;
}

export interface CategoryDetailParams {
  cat_id: number;
}

export interface CategoryDeleteParams {
  cat_id: number;
}

export interface AddCategoryRequest {
  cat_name: string;
  cat_short_name: string;
  cat_desc?: string;
  status?: number;
  cat_main_image?: File;
}

export interface UpdateCategoryRequest {
  cat_id: number;
  cat_name: string;
  cat_short_name: string;
  cat_desc?: string;
  status?: number;
  cat_main_image?: File;
}

// Status enums
export enum CategoryStatus {
  INACTIVES = 0,
  ACTIVES = 1,
  SUSPEND = 2,
  DELET = 3,
}

export enum ProductStatus {
  INACTIVE = 0,
  ACTIVE = 1,
  SUSPENDED = 2,
  DELETED = 3,
}

export enum ProductAvailability {
  UNAVAILABLE = 0,
  AVAILABLE = 1,
}

export enum DiscountType {
  PERCENTAGE = 1,
  FIXED_AMOUNT = 2,
}

// Form validation errors
export interface FormErrors {
  key: string ;
}

// Snackbar state
export interface SnackbarState {
  open: boolean;
  message: string;
  severity: 'success' | 'error' | 'warning' | 'info';
}


